import { DocumentModule } from './../document/document.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { InsuranceEditComponent } from './insurance-edit/insurance-edit.component';

@NgModule({
  declarations: [
    InsuranceEditComponent],
  imports: [
    CommonModule,
    SharedModule,
    DocumentModule
  ],
  exports: [
    InsuranceEditComponent
  ]
})
export class InsuranceModule { }
